import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export type Plan = {
  id: string;
  name: string;
  monthly_value: number;
  points: number;
  description: string;
  margin: number;
};

type ApiResponse = {
  success: boolean;
  message: string;
  data: Plan[];
  detail?: string;
};

export const fetchPlans = async () => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const response = await fetch(`${BASE_URL_API}/plans/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

  const { detail, ...rest } = (await response.json()) as ApiResponse;

  if (response.status !== 200) {
    throw new Error(detail);
  }

  return rest;
};
